import { render, staticRenderFns } from "./GetCertificateList.vue?vue&type=template&id=0a39083a&scoped=true&"
import script from "./GetCertificateList.vue?vue&type=script&lang=js&"
export * from "./GetCertificateList.vue?vue&type=script&lang=js&"
import style0 from "./GetCertificateList.vue?vue&type=style&index=0&id=0a39083a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a39083a",
  null
  
)

export default component.exports